module.exports = __webpack_public_path__ + "media/bg/quick_actions_bg-ec91d834.jpg";